import { render } from "./iQuelaNav.vue?vue&type=template&id=2e0abe00&scoped=true"
import script from "./iQuelaNav.vue?vue&type=script&lang=js"
export * from "./iQuelaNav.vue?vue&type=script&lang=js"

import "./iQuelaNav.vue?vue&type=style&index=0&id=2e0abe00&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\HP\\Desktop\\Proyectos Vue.js\\version-produccion-iquela\\Dashboard_usuarios\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0abe00"]])

export default __exports__